import { render, staticRenderFns } from "./bookmark-table.vue?vue&type=template&id=ec60e156"
import script from "./bookmark-table.vue?vue&type=script&lang=js"
export * from "./bookmark-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports